import React from "react";
import "./DetailContainer.scss";

import { connect } from "react-redux";

import DetailTitle from "components/DetailTitle/DetailTitle";
import ButtonGroup from "components/ButtonGroup/ButtonGroup";
import { reqNoticeDetail } from "store/Notice/Notice.store";

type Props = {
  noticeDetail: any;
  reqNoticeDetail: any;
  id: any;
};

const DetailContainer: React.FC<Props> = ({
  noticeDetail,
  reqNoticeDetail,
  id,
}) => {
  const content: any = React.useRef(null);

  React.useEffect(() => {
    reqNoticeDetail({ n_seq: id });
  }, [id, reqNoticeDetail]);

  React.useEffect(() => {
    if (!!noticeDetail) content.current.innerHTML = noticeDetail["body"];
  }, [noticeDetail]);

  return (
    <div className="DetailContainer">
      <div className="sub-header">
        <h1>네이트온 공지사항</h1>
        {/* <p>
          이전 공지사항 보기{" "}
          <img src={img.oldArrow} alt="arrow-icon" width="12" height="21" />
        </p> */}
      </div>
      <DetailTitle
        title={!!noticeDetail && noticeDetail["title"]}
        date={!!noticeDetail && noticeDetail["view_start_date"].split(" ")[0]}
        type={!!noticeDetail && noticeDetail["type"]}
      />
      <div className="content" ref={content}></div>
      <ButtonGroup />
    </div>
  );
};

export default React.memo(
  connect(
    ({ Notice }: any) => ({
      noticeDetail: Notice.noticeDetail,
    }),
    {
      reqNoticeDetail,
    }
  )(DetailContainer)
);
